<template>
  <Transition name="interrupt-toast">
    <output
      v-if="coins > 0"
      class="interrupt-toast"
    >
      <CoinToken size="md" />
      <p class="copy">{{ t('interrupt.toast', { n: coins }) }}</p>
    </output>
  </Transition>
</template>

<script setup lang="ts">
import { onUnmounted, watch } from 'vue'
import CoinToken from './CoinToken.vue'
import { useI18n } from '../i18n/t'
import {
  ackInterruptNotice,
  interruptNoticeCoins,
} from '../account/interruptNotice'

const TOAST_MS = 8_000

const { t } = useI18n()
const coins = interruptNoticeCoins
let hideTimer: ReturnType<typeof setTimeout> | null = null

function clearTimer(): void {
  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
}

watch(
  coins,
  (n) => {
    clearTimer()
    if (n <= 0) return
    void ackInterruptNotice()
    hideTimer = setTimeout(() => {
      interruptNoticeCoins.value = 0
    }, TOAST_MS)
  },
  { immediate: true },
)

onUnmounted(() => {
  clearTimer()
})
</script>

<style scoped>
.interrupt-toast {
  position: fixed;
  left: 50%;
  bottom: calc(88px + env(safe-area-inset-bottom, 0px));
  z-index: 10050;
  display: flex;
  align-items: center;
  gap: 12px;
  width: min(520px, calc(100vw - 32px));
  margin: 0;
  padding: 12px 16px;
  border-radius: 12px;
  background: var(--md-sys-color-surface-container-high);
  color: var(--md-sys-color-on-surface);
  box-shadow: var(--md-elevation-2);
  transform: translateX(-50%);
  font-family: Roboto, system-ui, sans-serif;
}

.copy {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
}

.interrupt-toast-enter-active,
.interrupt-toast-leave-active {
  transition:
    opacity var(--md-motion-short) var(--md-motion-standard),
    transform var(--md-motion-short) var(--md-motion-standard);
}

.interrupt-toast-enter-from,
.interrupt-toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(8px);
}

@media (prefers-reduced-motion: reduce) {
  .interrupt-toast-enter-active,
  .interrupt-toast-leave-active {
    transition: none;
  }
}
</style>
